

const host = "auth.negosyonow.com";
const protocol = "https";
const suffix = "consent/";

//https://iabeurope.eu/vendor-list-tcf/
const tcfvendorlist = [
	{
		"name": "Google Advertising Products",
		"vendorid": 755,
		"purposeidlist": [1,3,4,7,9,10]
	}
];

const tcfnonvendorlist = [
	{
		"name": "Meta Platforms, Inc. (Facebook)",
		"vendorid": "meta",
		"purposeidlist": [1,3,4,7]
	},
	{
		"name": "Microsoft Corporation",
		"vendorid": "ms",
		"purposeidlist": [1,7]
	}
];




export default {
	host,
	protocol,
	suffix,
	tcfvendorlist,
	tcfnonvendorlist
};

